import { InjectionToken } from '@angular/core';

import {
  Overlay
} from '@angular/cdk/overlay';
import type {
  ScrollStrategy
} from '@angular/cdk/overlay';

export type SideSheetSelectorStrategyFunc = () => ScrollStrategy;

export const SIDE_SHEET_SELECTOR_SCROLL_STRATEGY = new InjectionToken<SideSheetSelectorStrategyFunc>('sideSheetSelectorScrollStrategy');

export const SIDE_SHEET_SELECTOR_SCROLL_STRATEGY_PROVIDER_FACTORY = (overlay: Overlay): SideSheetSelectorStrategyFunc => (): ScrollStrategy => overlay.scrollStrategies.close({ threshold: 2 });

export const SIDE_SHEET_SELECTOR_SCROLL_STRATEGY_PROVIDER = {
  provide: SIDE_SHEET_SELECTOR_SCROLL_STRATEGY,
  deps: [Overlay],
  useFactory: SIDE_SHEET_SELECTOR_SCROLL_STRATEGY_PROVIDER_FACTORY
};
